export default __webpack_public_path__ + "static/ctaModule_table_desktop-b1bcc69c9461e5476cba0fb40c17fe1c.png";